module.exports = __webpack_public_path__ + "img/2025-03-05-01-01.fbd6792a.png";